import { trim } from '../stringUtils';

export function getObservationTitle(observation, useIcons = true) {
    if (observation.type === 'visualInspection') {
        return (useIcons ? '👁️ ' : '') + observation.contentInspection;
    } else if (observation.type === 'question') {
        return (useIcons ? '❓ ' : '') + observation.contentQuestion;
    } else {
        return 'Observation ' + observation.id;
    }
}

export function getObservationGroupTitle(observationGroup) {
    let observationGroupTitle;

    if (observationGroup.title) {
        observationGroupTitle = observationGroup.title;
    } else {
        observationGroupTitle = 'Observation group ' + (observationGroup.index + 1);
    }

    // Add info for the first observation
    if (observationGroup.observations) {
        let observationKeys = Object.keys(observationGroup.observations);

        if (observationKeys.length) {
            let firstObservationKey = Object.keys(observationGroup.observations)[0];

            if (observationGroup.observations.hasOwnProperty(firstObservationKey)) {
                let firstObservation = observationGroup.observations[firstObservationKey];

                if (firstObservation) {
                    observationGroupTitle += ' - ' + trim(getObservationTitle(firstObservation), 80);
                }
            }
        }
    }

    return observationGroupTitle;
}

export function getIndicatorTitle(indicator) {
    return indicator.rowNumber + ' | ' + indicator.indicator;
}